export default "__VITE_ASSET__CpxD5qfi__"